import { Dimension } from '@hungryroot/ramen';
import {
  ManageCartButton,
  type ManageCartButtonProps,
} from '../ManageCartButton/ManageCartButton';
import styles from './Footer.module.css';

export const Footer = (props: ManageCartButtonProps) => {
  const {
    onAddClick,
    onSubtractClick,
    creditsForItem,
    numInCart,
    onRemoveClick,
    onIncrementClick,
    isLoading,
    outOfStock,
    isDisabled,
  } = props;
  return (
    <Dimension level="two" className={styles.footer}>
      <ManageCartButton
        onAddClick={onAddClick}
        onRemoveClick={onRemoveClick}
        onSubtractClick={onSubtractClick}
        onIncrementClick={onIncrementClick}
        creditsForItem={creditsForItem}
        numInCart={numInCart}
        isLoading={isLoading}
        isDisabled={isDisabled}
        outOfStock={outOfStock}
      />
    </Dimension>
  );
};
